var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 31.05a3.68 3.68 0 1 0-3.68-3.68 3.68 3.68 0 0 0 3.68 3.68zm0-5.36a1.68 1.68 0 1 1-1.68 1.68 1.68 1.68 0 0 1 1.68-1.68zm6.83 7.91a3.68 3.68 0 1 0 3.68 3.68 3.69 3.69 0 0 0-3.68-3.68zm0 5.36a1.68 1.68 0 1 1 1.68-1.68A1.68 1.68 0 0 1 26.43 39zM16.725 39.205l10.66-14.9 1.626 1.164-10.659 14.9zM43 26h2v4h-2zM43 34h2v4h-2z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 15H48a1 1 0 0 0-.71.29L44 18.59l-3.29-3.3A1 1 0 0 0 40 15H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1 2 2 0 0 1 0 4 1 1 0 0 0-1 1v3a1 1 0 0 0 1 1 2 2 0 0 1 0 4 1 1 0 0 0-1 1v3a1 1 0 0 0 1 1 2 2 0 0 1 0 4 1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h36a1 1 0 0 0 .71-.29l3.29-3.3 3.29 3.3A1 1 0 0 0 48 49h12a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1 2 2 0 0 1 0-4 1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1 2 2 0 0 1 0-4 1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1 2 2 0 0 1 0-4 1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-1 4.13a4 4 0 0 0 0 7.74v1.26a4 4 0 0 0 0 7.74v1.26a4 4 0 0 0 0 7.74V47H48.41L45 43.59V42h-2v1.59L39.59 47H5v-2.13a4 4 0 0 0 0-7.74v-1.26a4 4 0 0 0 0-7.74v-1.26a4 4 0 0 0 0-7.74V17h34.59L43 20.41V22h2v-1.59L48.41 17H59Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountCoupon);
export default __webpack_public_path__ + "static/media/discountCoupon.2b9c3391c668f2280696f2a715719d3c.svg";
export { ForwardRef as ReactComponent };